/* eslint-disable */
import * as Hammer from 'hammerjs';
import { debounce, wrapInner, wrap, isSafari, isMobile } from '../../utils';

import './style.scss';

class Slider {
  constructor({
    selector,
    itemWidth,
    margin = 0,
    inactive = false,
    responsive,
    activeSlide = 0,
    isSetNavButtonsPosition = true,
    isSetStageWidth = true,
    isHideNav = false
  }) {
    this.selector = selector;
    this.options = arguments[0];
    this.itemWidth = itemWidth;
    this.margin = margin;
    this.responsive = responsive;
    this.activeSlide = activeSlide;
    this.isSetNavButtonsPosition = isSetNavButtonsPosition;
    this.isSetStageWidth = isSetStageWidth;
    this.isHideNav = isHideNav;

    this.wrapper = null;
    this.viewport = null;
    this.stage = null;
    this.slideItems = null;
    this.nav = null;
    this.prevBtn = null;
    this.nextBtn = null;

    this.state = {
      initialized: false,
      current: null,
      inactive,
    };

    this.run();

    window.addEventListener('resize', debounce(this.refresh.bind(this), 250));
  }

  setDefaultState() {
    this.itemWidth = this.options.itemWidth;
    this.margin = this.options.margin;
    this.state.inactive = this.options.inactive;
  }

  preInit() {
    const wrapper = document.createElement('div');
    wrapper.classList.add('slider__wrapper');

    isSafari ? wrapper.classList.add('slider__wrapper--safari') : null;

    const viewport = document.createElement('div');
    viewport.classList.add('slider__viewport');

    const stageWrapper = document.createElement('div');
    stageWrapper.classList.add('slider__stage-wrapper');

    const stage = document.createElement('div');
    stage.classList.add('slider__stage');

    this.wrapper = wrapper;
    this.viewport = viewport;
    this.stage = stage;

    this.selector.classList.add('slider--preinited');

    wrapInner(this.selector, this.stage);
    wrap(this.stage, stageWrapper);
    wrap(stageWrapper, this.viewport);
    wrap(this.viewport, this.wrapper);

    this.slideItems = this.stage.children;

    Array.prototype.slice.call(this.slideItems).forEach(item => {
      const slideItemWrapper = document.createElement('div');

      slideItemWrapper.classList.add('slider__item');
      wrap(item, slideItemWrapper);
    });
  }

  init() {
    this.selector.classList.add('slider--inited');
    this.state.initialized = true;
  }

  calcPaddingToCenter() {
    return (this.selector.offsetWidth - this.itemWidth) / 2;
  }

  changeSlide(index) {
    const direction = index > 0 ? -1 : 1;

    const dots = this.selector.querySelectorAll('.slider__dots-item');

    dots[this.state.current].classList.remove('slider__dots-item--active');

    this.move(index, direction);

    dots[this.state.current].classList.add('slider__dots-item--active');
    this.slideItems[this.state.current].classList.add('slider__item--active');
  }

  next() {
    this.changeSlide(this.state.current + 1);
    this.hideNav();
  }

  prev() {
    this.changeSlide(this.state.current - 1);
    this.hideNav();
  }

  hideNav() {
  if (isMobile && this.isHideNav) {
      const nav = document.querySelector('.slider__nav');
      nav.classList.add('slider__nav--hidden');

      setTimeout(()=> {
        nav.classList.remove('slider__nav--hidden');
      }, 600);
    }
  }

  generateNav() {
    const template = `<button class="slider__button slider__button--prev">
            <span></span>
        </button>
        <button class="slider__button slider__button--next">
            <span></span>
        </button>`;

    const nav = document.createElement('div');

    nav.classList.add('slider__nav');
    nav.innerHTML = template;

    this.wrapper.appendChild(nav);
    this.nav = nav;

    this.prevBtn = nav.querySelector('.slider__button--prev');
    this.nextBtn = nav.querySelector('.slider__button--next');

    this.prevBtn.addEventListener('click', () => {
      this.prev();
    });

    this.nextBtn.addEventListener('click', () => {
      this.next();
    });

    this.setNavButtonsPosition();
  }

  generateDots() {
    const template = `<div class="slider__dots-inner">
        ${'<button class="slider__dots-item"><span></span></button>'.repeat(
          this.slideItems.length
        )}
        </div>`;

    const dots = document.createElement('div');

    dots.classList.add('slider__dots');
    dots.innerHTML = template;

    this.wrapper.appendChild(dots);

    const dotItems = dots.querySelectorAll('.slider__dots-item');

    dots.addEventListener('click', e => {
      if (e.target.classList.contains('slider__dots-item')) {
        const index = Array.prototype.indexOf.call(dotItems, e.target);
        if (index !== this.state.current) this.changeSlide(index);
      }
    });
  }

  attachSwipeHandlers() {
    const hammer = new Hammer(this.stage, {});

    const swipeFunc = e => {
      if (e.deltaX < 0) {
        this.next();
      } else {
        this.prev();
      }
    };

    hammer.on('swipe', e => debounce(swipeFunc(e), 150));
  }

  setNavButtonsPosition() {
    if (this.isSetNavButtonsPosition) {
      this.prevBtn.style.left = `${this.selector.offsetWidth / 2 -
        this.prevBtn.offsetWidth -
        this.itemWidth / 2 -
        this.margin / 8}px`;
      this.nextBtn.style.right = `${this.selector.offsetWidth / 2 -
        this.nextBtn.offsetWidth -
        this.itemWidth / 2 -
        this.margin / 8}px`;
    }
  }

  run() {
    if (this.selector.classList.contains('slider--preinited')) return false;

    this.getResponsiveProps();

    if (this.state.inactive) return false;

    if (!this.state.initialized) {
      this.preInit();
      this.generateNav();
      this.attachSwipeHandlers();
      this.generateDots();
      this.state.current = this.activeSlide;
    }

    this.setItemsWidth();
    this.setStageWidth();

    this.changeSlide(this.state.current);

    if (!this.state.initialized) {
      this.init();
    }
  }

  refresh() {
    this.getResponsiveProps();

    if (this.state.inactive) {
      this.deactivate();

      return false;
    }

    this.run();
    this.setNavButtonsPosition();
    this.onRefresh();
  }

  onRefresh() {
    /* eslint-disable-line */
    // your code
  }

  deactivate() {
    if (this.state.initialized) {
      this.destroy();
      this.state.initialized = false;
    }
  }

  destroy() {
    Array.prototype.slice.call(this.slideItems).forEach(item => {
      this.selector.appendChild(item.children[0]);
    });

    this.wrapper.remove();
  }

  setItemsWidth() {
    Array.prototype.slice.call(this.slideItems).forEach(item => {
      item.style.width = `${this.itemWidth}px`;
      item.style.marginRight = this.margin ? `${this.margin}px` : '';
    });
  }

  calculateStageWidth() {
    return this.slideItems.length * (this.itemWidth + this.margin);
  }

  setStageWidth() {
    if (this.isSetStageWidth) {
      this.stage.style.width = `${this.calculateStageWidth()}px`;
    }
  }

  getWindowWidth() {
    /* eslint-disable-line */
    return window.innerWidth; /* eslint-disable-line */
  }

  getResponsiveProps() {
    const breakPoints = [];

    for (const breakPoint in this.responsive) {
      if (this.getWindowWidth() >= parseInt(breakPoint, 10)) {
        breakPoints.push(this.responsive[breakPoint]);
      }
    }

    this.setDefaultState();

    if (breakPoints.length > 0) {
      breakPoints.forEach(item => {
        for (const prop in item) {
          if (this.hasOwnProperty(prop)) this[prop] = item[prop];
          if (this.state.hasOwnProperty(prop)) this.state[prop] = item[prop];
        }
      });
    } else {
      this.setDefaultState();
    }
  }
}

export default Slider;
